import type { ExperimentClient } from '@amplitude/experiment-js-client';
import { Experiment } from '@amplitude/experiment-js-client';

import { env } from '~/lib/env';

import { AMPLITUDE_EXPERIMENT_DEV_PROXY_URL } from './constants';

let client: ExperimentClient | null = null;

/**
 * Initializes the Experiment client with the provided deployment key.
 * @returns The initialized Experiment client.
 */
export function initializeExperimentClient(): ExperimentClient {
  if (!client) {
    client = Experiment.initializeWithAmplitudeAnalytics(
      env('VITE_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY'),
      {
        serverUrl: origin.includes('localhost')
          ? AMPLITUDE_EXPERIMENT_DEV_PROXY_URL
          : origin,
      },
    );
  }

  return client;
}

/**
 * Fetches the latest feature flags and variants for the user.
 * @returns The value of the feature flag or the default value if not set.
 */
export function getVariant(flagKey: string, defaultValue = 'off') {
  return (client?.variant(flagKey)?.value ?? defaultValue).trim().toLowerCase();
}
